/*
Sohel 10/20/2023 5314470832 Added Agent / Advocate Information Screen
*/
import {Grid, Button, TextField} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useContext} from 'react';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';

import {ThemeContext} from '../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const AddWindow = ({setWindowData, windowData, setOpenWindow, windowRowData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const types = [
    {key: 'Core', value: 'Core'},
    {key: 'Client', value: 'Client'},
  ];
  const coreData = [
    {key: 'Account Guarantor', value: 'W61'},
    {key: 'Account Notes', value: 'W32'},
    {key: 'Add a Note', value: 'W8'},
    {key: 'CBS Insurance', value: 'W6'},
    {key: 'Address History', value: 'W11'},
    {key: 'Agent / Advocate Information', value: 'AGENT_INFO'},
    {key: 'Client Information', value: 'W13'},
    {key: 'Communication History', value: 'W52 W95'},
    {key: 'Patient / Customer Demographics', value: 'W2'},
    {key: 'Document Management', value: 'W47'},
    {key: 'Messages', value: 'W44'},
    {key: 'Status Timeline', value: 'D'},
  ];
  const clientData = [
    {key: 'Corresponding Clients (W3)', value: 'W3'},
    {key: 'Collection (W4)', value: 'W4'},
    {key: 'New Business (W5)', value: 'W5'},
    {key: 'Client Notes (W7)', value: 'W7'},
    {key: 'Billing (W16)', value: 'W16'},
    {key: 'Debtor Cash (W18)', value: 'W18'},
    {key: 'Statement (W19)', value: 'W19'},
  ];

  const getObject = (data, options) => {
    let label = {};
    options?.map((item) => {
      if (item?.value === data) {
        label = item;
      }
      return label;
    });
  };
  const initialValues = {
    roleName: windowRowData ? windowRowData?.roleName : '',
    windowName: windowRowData ? windowRowData?.windowName : '',
    module: windowRowData ? getObject(windowRowData?.module, types) : '',
    roleDescription: windowRowData ? windowRowData?.roleDescription : '',
  };

  const handleSubmit = (data) => {
    const updatedData = [...windowData];
    updatedData?.push({...data});
    setWindowData(updatedData);
    setOpenWindow(false);
  };
  return (
    <div>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleReset, handleBlur, setFieldValue} = props;
            return (
              <div className="col-md-12">
                <Form autoComplete="off">
                  <div className={`${classes.cardStyles} m-0`}>
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2}>
                        <>
                          <Grid xs={4} item className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Name`}
                              label="Role Name"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="roleName"
                              value={values.roleName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid xs={4} item className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Description`}
                              label="Role Description"
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="roleDescription"
                              value={values.roleDescription}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid xs={4} item className={`form-group ${classes.selectdropdown}`}>
                            <GuiAutoComplete
                              classes={{
                                popper: classes.popper,
                                option: classes.option,
                              }}
                              name="module"
                              id="module"
                              size="small"
                              value={values.module}
                              options={types}
                              getOptionDisabled={(option) => option.valueCode === null}
                              getOptionLabel={(option) => {
                                return option && option.key && option.value ?
                                  option.value :
                                  option.value === null ?
                                    option.key :
                                    option.value;
                              }}
                              required
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('module', value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Module"
                                    placeholder="Select Module"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                          <Grid xs={8} item className={`form-group ${classes.selectdropdown}`}>
                            <GuiAutoComplete
                              name="windowName"
                              id="windowName"
                              size="small"
                              value={values.windowName}
                              options={values?.module?.value === 'Core' ? coreData : clientData}
                              getOptionDisabled={(option) => option.valueCode === null}
                              getOptionLabel={(option) => {
                                return option && option.Key && option.value ?
                                  option.key :
                                  option.key === null ?
                                    option.value :
                                    option.key;
                              }}
                              required
                              disabled={!values?.module}
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('windowName', value);
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    className={` ${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="Window Name"
                                    placeholder="Select Window Name"
                                  />
                                </div>
                              )}
                            />
                          </Grid>
                        </>
                      </Grid>
                    </ErrorBoundaryForComponents>
                    <div className="button-spacing-mb">
                      <Button
                        variant="contained"
                        className={`mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        className={`mx-1 themeing-buttons ${classes.buttonRoot}`}
                        color="primary"
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Form>
                {/* {isLoading && <PageLoader />} */}
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddWindow;
